"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGuessSettleStatusLabel = exports.GUESS_SETTLE_STATUS_LABEL = void 0;
exports.GUESS_SETTLE_STATUS_LABEL = {
    0: 'PENDING',
    1: 'WON',
    2: 'LOST',
    3: 'PUSH',
};
const getGuessSettleStatusLabel = (settleStatus) => {
    return exports.GUESS_SETTLE_STATUS_LABEL[settleStatus] ?? 'PENDING';
};
exports.getGuessSettleStatusLabel = getGuessSettleStatusLabel;
